// extracted by mini-css-extract-plugin
module.exports = {"paneStatus":"EmailReviewHost_paneStatus__nGtBz","review":"EmailReviewHost_review__xjKwx","notice":"EmailReviewHost_notice__BAaDD"};